import { render } from "./ConfirmationSection.vue?vue&type=template&id=3aba9fbe&scoped=true"
import script from "./ConfirmationSection.vue?vue&type=script&lang=js"
export * from "./ConfirmationSection.vue?vue&type=script&lang=js"

import "./ConfirmationSection.vue?vue&type=style&index=0&id=3aba9fbe&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aba9fbe"]])

export default __exports__